import { Types } from '@scorenco/core';

export const createKeywords = (
  event: Types.Competitions_Event_Detail | undefined,
  groups: Types.Competitions_Playing_Team_Info | undefined,
  setKeywords: (keywords: string[]) => void
) => {
  const newKeywords = [
    ...(event?.teams || []).reduce(
      (acc, team) => [...acc, team.name_in_club, team.name_in_competition],
      new Array<string | undefined>()
    ),
    ...(groups?.referees || []).reduce(
      (acc, member) => [
        ...acc,
        member.member?.first_name + ' ' + member.member?.last_name,
        member.member?.last_name + ' ' + member.member?.first_name,
      ],
      new Array<string>()
    ),
    ...(groups?.stadium_managers || []).reduce(
      (acc, member) => [
        ...acc,
        member.member?.first_name + ' ' + member.member?.last_name,
        member.member?.last_name + ' ' + member.member?.first_name,
      ],
      new Array<string>()
    ),
    ...(groups?.bar_managers || []).reduce(
      (acc, member) => [
        ...acc,
        member.member?.first_name + ' ' + member.member?.last_name,
        member.member?.last_name + ' ' + member.member?.first_name,
      ],
      new Array<string>()
    ),
    ...(groups?.scoring_table_managers || []).reduce(
      (acc, member) => [
        ...acc,
        member.member?.first_name + ' ' + member.member?.last_name,
        member.member?.last_name + ' ' + member.member?.first_name,
      ],
      new Array<string>()
    ),
    ...(groups?.jobs?.reduce(
      (acc, job) => [
        ...acc,
        ...(job.volunteers || []).reduce(
          (acc, member) => [
            ...acc,
            member.member?.first_name + ' ' + member.member?.last_name,
            member.member?.last_name + ' ' + member.member?.first_name,
          ],
          new Array<string>()
        ),
      ],
      new Array<string>()
    ) || []),
  ].filter(Boolean) as string[];

  setKeywords(newKeywords);
};
